import React, { FC } from 'react'
import { Restore } from '@mui/icons-material'
import { Box, CircularProgress, IconButton } from '@mui/material'

type UpdateButtonType = {
  isShowButton: boolean
  onClick: () => void
  isLoading: boolean
}

export const UpdateButton: FC<UpdateButtonType> = props => {
  const { isLoading, onClick, isShowButton } = props

  if (!isShowButton) {
    return null
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={14} />
      </Box>
    )
  }

  return (
    <IconButton sx={{ width: 32, height: 32 }} onClick={onClick}>
      <Restore />
    </IconButton>
  )
}
